module.exports = __webpack_public_path__ + "media/images/conlance_logo_mobile-6a3d4d072d65e1808603a31073fb57ed.svg";